<ngx-spinner>
  
</ngx-spinner>

<div class="main" [class.example-is-mobile]="mobileQuery.matches">

  <app-nav (toggle)="snav.toggle()"></app-nav>

  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 60">

    <mat-sidenav #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
    [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" closed [style.paddingTop.px]="mobileQuery.matches ? 0 : 0" class="navArea">
      <mat-nav-list>

        <ng-container *ngIf="accountService.currentUser$ | async">
          <ng-container *ngFor="let nav of links">
            <a mat-list-item 
              [routerLink]="nav.path"
              routerLinkActive="active" 
              *appHasRole="nav.roles">
          
            <mat-icon color="primary">{{nav.icon}}</mat-icon>
            {{nav.title}}
          </a>
          </ng-container>
          

          <!-- <a  mat-list-item routerLink="errors">Errors</a> -->
        </ng-container>

      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="content" [style.paddingTop.px]="mobileQuery.matches ? 0 : 10">
      <router-outlet></router-outlet>
        <!-- <app-home></app-home> -->
      <!-- <ul>
        <li *ngFor="let item of users">
          {{item.userName}}
        </li>

      </ul> -->
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<!-- <div style="position: relative;">
  <button mat-fab color="primary" 
  aria-label="Example icon button with a delete icon" 
  style="position: fixed; z-index: +300; bottom: 40px; right: 20px;"
  routerLink="/">
    <mat-icon>home</mat-icon>
  </button>
</div> -->